import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import { Card, Spin, Alert } from 'antd'
import { GET_ORDER_CARGO_PROFILE } from '../../graphql/orderCargoProfile'

const OrderCargoProfile = ({ orderNumber, i18n }) => {
  const { data, loading, error } = useQuery(GET_ORDER_CARGO_PROFILE, {
    variables: { orderNumber },
    skip: !orderNumber
  })

  if (loading) {
    return (
      <Card title={i18n.t('inquiries:cargoProfile')} size="small">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin />
        </div>
      </Card>
    )
  }

  if (error) {
    return (
      <Card title={i18n.t('inquiries:cargoProfile')} size="small">
        <Alert
          message={i18n.t('inquiries:error')}
          description={error.message}
          type="error"
          showIcon
        />
      </Card>
    )
  }

  const cargoProfilesEdges = (data && data.order && data.order.cargoProfiles && data.order.cargoProfiles.edges) || []
  const cargoProfiles = cargoProfilesEdges.map(edge => edge.node)

  if (cargoProfiles.length === 0) {
    return (
      <Card title={i18n.t('inquiries:cargoProfile')} size="small">
        <div style={{ color: '#999', textAlign: 'center', padding: '20px' }}>
          {i18n.t('inquiries:noCargoProfile')}
        </div>
      </Card>
    )
  }

  return (
    <Card title={i18n.t('inquiries:cargoProfile')} size="small">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {cargoProfiles.map((cargoProfile, index) => (
          <div 
            key={cargoProfile.id || index}
            style={{ 
              padding: '8px 12px',
              backgroundColor: '#fafafa',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '14px'
            }}
          >
            <span style={{ fontWeight: 'bold', marginRight: '8px' }}>
              {index + 1}.
            </span>
            {cargoProfile.saleDisplayName || cargoProfile.code || i18n.t('inquiries:noDisplayName')}
          </div>
        ))}
      </div>
    </Card>
  )
}

OrderCargoProfile.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired
}

export default withTranslation('inquiries')(OrderCargoProfile)
